import React from "react";
import "./BanksModal.scss";
import ReactModal from "react-modal";
import { Col, Form } from "react-bootstrap";
import { Formik } from "formik";
import Cleave from "cleave.js/react";
import Loader from "../loader/loader";
import * as yup from "yup";
import { changeSignerEmail } from "../../api/index";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const schema = yup.object({
    showRequiredField: yup.string().oneOf(["yes", "no"]),
    email: yup
        .string()
        .email("* Input a valid email address.")
        .when("showRequiredField", (fieldRequired, schema) => {
            return fieldRequired === "yes"
                ? schema.required("*Email is required")
                : schema;
        }),
});

class EditEmailModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show_spinner: false,
            formData: {
                email: props.email ? props.email : "",
                email_2: props.email_2 !== null ? props.email_2 : null,
            },
            errors: [],
        };
    }

    onSubmit = async () => {
        const formData = this.state.formData;
        let data = new FormData();
        let email = formData.email;
        data.append("email", email);

        if (formData.email_2) {
            let email2 = formData.email_2;
            data.append("email_2", email2);
        }

        data.append("editslug", this.props.slug);
        data.append("id", this.props.appId);
        this.setState({ show_spinner: true });

        changeSignerEmail(data)
            .then((response) => {
                if (response.status) {
                    this.setState({ show_spinner: false });
                    this.props.emailUpdate();
                } else {
                    this.setState({ show_spinner: false });
                    this.props.handleClose();
                }
            })
            .catch((error) => console.log(error));
    };

    handleOnChange = (e) => {
        const targetName = e.target.name;
        let formData = this.state.formData;
        const rawValue = e.target.rawValue || "";

        if (rawValue) {
            this.setState((prevState) => ({
                ...prevState,
                [targetName]: rawValue.trim(),
            }));
        }

        formData[targetName] = e.target.rawValue.trim();
    };

    render() {
        const { show_spinner, formData } = this.state;

        return (
            <ReactModal isOpen={this.props.show} className="banks-modal">
                <div className="modal-header">
                    <h4 className="text-left">Please enter your email</h4>
                </div>
                <div className="modal-body" style={{ marginTop: "50px" }}>
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.onSubmit(e)}
                        initialValues={formData}
                        validateOnBlur={false}
                    >
                        {({
                            errors,
                            touched,
                            handleChange,
                            values,
                            handleSubmit,
                        }) => (
                            <Form
                                noValidate
                                autoComplete="off"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.handleOnChange(e)}
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="d-flex flex-row phone-prefix">
                                            <Cleave
                                                options={{
                                                    blocks: [],
                                                    delimiter: "-",
                                                    numericOnly: false,
                                                }}
                                                required
                                                placeholder="Enter email"
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                type="text"
                                                className={`preapp-form-input form-control ${
                                                    !errors.email && ""
                                                } ${
                                                    touched.email &&
                                                    !!errors.email &&
                                                    "is-invalid"
                                                }`}
                                            />
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        {this.props.email_2 !== null && (
                                            <div className="d-flex flex-row phone-prefix">
                                                <Cleave
                                                    options={{
                                                        blocks: [],
                                                        delimiter: "",
                                                        numericOnly: false,
                                                    }}
                                                    required
                                                    placeholder="Secondary email"
                                                    name="email_2"
                                                    value={values.email_2}
                                                    onChange={handleChange}
                                                    type="text"
                                                    className={`preapp-form-input form-control ${!errors.email_2 && ""} ${
                                                        touched.email_2 &&
                                                        !!errors.email_2 &&
                                                        "is-invalid"
                                                    }`}
                                                />
                                            </div>
                                        )}
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.email_2}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <div
                                    className="modal-footer"
                                    style={{ marginTop: "250px" }}
                                >
                                    <button
                                        className="btn cancel-button"
                                        onClick={this.props.handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn confirm-button"
                                        type="submit"
                                    >
                                        Update
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
            </ReactModal>
        );
    }
}

export default EditEmailModal;
